export default{
    data(){
        return{
            tableLoading:true
        }
    },
    methods: {
        loadPageData(){
            this.loadData()
        }
    },
}